import { get } from '../base';

import { Collection } from './types';

export async function getStoreCollections({ posId }: { posId: string }): Promise<{ collections: Collection[] }> {
  return get(`v4/shops/byId/${posId}`).json();
}
